// @flow

const albaikBrightRed = "#ec3727";
const albaikIconRed = "#ed3424";
const albaikRed = (alpha = 1.0) => `rgba(237, 52, 36, ${alpha})`;
const deepRed = "#cb2618";
const whiteAlpha = (alpha: number): string =>
  `rgba(255, 255, 255, ${alpha || 0})`;
const white = "rgb(255, 255, 255)";
const whiteLabel = "rgba(255,255,255, 0.65)";
const separatorGray = (alpha = 1.0): string =>
  `rgba(244, 237, 231, ${alpha || 0})`;
const transparentButton = separatorGray(0.2);
const statusBackground = separatorGray(0.15);
const disabledTransparentButton = separatorGray(0.1);
const dullWhite = "rgb(230, 231, 232)";
const cardBackgroundWhite = "rgb(244,244,244)";
const almostWhite = "rgb(247,247,247)";
const gray = "rgb(180,180,180)";
const beige = "rgb(243, 237, 232)";
const iconWhite = "#7f8594";
const lightBrown = "rgb(130,7,8)";
const cedarAlpha = (alpha = 1): string => `rgba(99, 27, 2, ${alpha})`;
const cedar = cedarAlpha();
const cedar10 = cedarAlpha(0.1);
const cedar30 = cedarAlpha(0.3);
const cedar70 = cedarAlpha(0.7);
const veryLightMaroon = cedarAlpha(0.05);
const emerald = "rgb(16, 179, 112)";
const albaikRed50 = albaikRed(0.5);
const blackAlpha = (alpha = 1): string => `rgba(0, 0, 0, ${alpha})`;
const black = blackAlpha();
const casablanca = "#F6C64D";
const yellow = "rgb(255,241,0)";
const receiptYellow = "rgb(255,232,0)";
const maroon = "rgb(99, 27, 2)";
const darkTextLabelColor = "rgba(99, 27, 2, 0.65)";
const brownAlpha = (alpha = 1): string => `rgba(62, 16, 0, ${alpha})`;
const transparentBlack = blackAlpha(0.95);
const blackTint = blackAlpha(0.4);
const blue = "rgb(32,119,231)";
const green = "rgb(32,119,0)";
const shadowBlack = blackAlpha(0.15);

export const colors = {
  // color definitions
  albaikBrightRed,
  albaikIconRed,
  albaikRed: albaikRed(),
  gray,
  almostWhite,
  white,
  whiteLabel,
  whiteAlpha,
  dullWhite,
  beige,
  cedar,
  cedar10,
  cedar30,
  emerald,
  albaikRed50,
  black,
  casablanca,
  yellow,
  receiptYellow,
  deepRed,
  cardBackgroundWhite,
  iconWhite,
  maroon,
  darkTextLabelColor,
  mapBorder: albaikRed(0.25),
  mapCircle: albaikRed(0.15),
  transparentBlack,
  blue,
  green,
  veryLightMaroon,
  shadowBlack,
  blackTint,
  // semantic colors
  primary: albaikRed(),
  error: albaikRed(),
  success: emerald,
  navText: albaikRed(),
  disabledNavText: albaikRed50,
  text: cedar,
  secondaryText: cedar70,
  disabledText: cedarAlpha(0.5),
  cedarAlpha,
  transparentButton,
  statusBackground,
  disabledTransparentButton,
  separatorGray,
  blackAlpha,
  brownAlpha,
  lightBrown,
};

export const themes = {
  dark: "dark",
  light: "light",
};

export * from "./fonts";
